import React from "react";
import { classNames } from "../../helpers";

import clubSchedule from "../../assets/member-menu/club-schedule.png";
import clubWebshop from "../../assets/member-menu/club-webshop.png";
import contactClub from "../../assets/member-menu/contact-club.png";
import logout from "../../assets/member-menu/logout.png";
import myBookings from "../../assets/member-menu/my-bookings.png";
import myProfile from "../../assets/member-menu/my-profile.png";
import myPurchases from "../../assets/member-menu/my-purchases.png";

/**
 * Icons from the FitClub iOS app (Assets.xcassets), used in the member menu on the web.
 * club-webshop.png is drawn in the same style (96 px, 6 px rounded stroke); the others are copies of the iOS PNGs:
 * club-schedule = tab-schedule, my-purchases = icon-buy, my-bookings = tab-bookings, my-profile = icon-profile,
 * contact-club = icon-help (Chat), logout = icon-logout.
 */
export const MEMBER_ICONS = { clubSchedule, clubWebshop, contactClub, logout, myBookings, myProfile, myPurchases };

/** A PNG icon used as a mask, so it takes the text colour (currentColor) like an SVG icon. */
export default function MaskIcon({ src, className = "size-6" }) {
  const url = `url(${src})`;
  return (
    <span
      aria-hidden="true"
      className={classNames("inline-block shrink-0 bg-current", className)}
      style={{
        WebkitMaskImage: url,
        maskImage: url,
        WebkitMaskRepeat: "no-repeat",
        maskRepeat: "no-repeat",
        WebkitMaskPosition: "center",
        maskPosition: "center",
        WebkitMaskSize: "contain",
        maskSize: "contain",
      }}
    />
  );
}
